<template>
  <section
    class="block-content mb-5 overflow-hidden"
    data-aos="fade-up"
    data-aos-duration="1000"
    data-aos-offset="100"
  >
    <div class="container my-md-5 py-md-5">
      <div
        class="bg-animation bg-right d-none d-md-block"
        data-aos="fade-up"
        data-aos-duration="1500"
        data-aos-offset="100"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="animatedSVG"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 300 300"
        >
          <linearGradient
            id="svggradient"
            gradientUnits="userSpaceOnUse"
            x1="22.9255"
            y1="150.313"
            x2="277.0436"
            y2="150.313"
          >
            <stop offset="0" style="stop-color: #e30613" />
            <stop offset="1" style="stop-color: #000000" />
          </linearGradient>
          <path
            class="p1"
            d="M204.1,23.3H95.9c-40.3,0-73,32.7-73,73v108.1c0,40.3,32.7,73,73,73h108.1c40.3,0,73-32.7,73-73V96.2C277,55.9,244.4,23.3,204.1,23.3z M275.1,202.3c0,40.3-32.7,73-73,73h-104c-40.3,0-73-32.7-73-73v-104c0-40.3,32.7-73,73-73h104c40.3,0,73,32.7,73,73V202.3z"
          />
          <path
            class="p2"
            d="M278.1,98.7l-76.5-76.5c-28.5-28.5-74.7-28.5-103.2,0L21.9,98.7c-28.5,28.5-28.5,74.7,0,103.2l76.5,76.5c28.5,28.5,74.7,28.5,103.2,0l76.5-76.5C306.6,173.4,306.6,127.2,278.1,98.7z M201.7,275.5c-28.5,28.5-74.7,28.5-103.2,0L24.9,202c-28.5-28.5-28.5-74.7,0-103.2l73.6-73.6c28.5-28.5,74.7-28.5,103.2,0l73.6,73.6c28.5,28.5,28.5,74.7,0,103.2L201.7,275.5z"
          />
          <path
            class="p3"
            d="M230.7,64.4l-93.6-40.7c-34.9-15.2-75.5,0.8-90.6,35.7L5.7,152.9c-15.2,34.9,0.8,75.5,35.7,90.6l93.6,40.7c34.9,15.2,75.5-0.8,90.6-35.7l40.7-93.6C281.5,120.2,265.6,79.6,230.7,64.4z M224.7,246.1C209.5,281,168.9,297,134,281.8l-90-39.2C9.2,227.4-6.8,186.8,8.4,152l39.2-90c15.2-34.9,55.8-50.8,90.6-35.7l90,39.2c34.9,15.2,50.8,55.8,35.7,90.6L224.7,246.1z"
          />
        </svg>
      </div>
      <div
        class="row my-5 py-5 align-items-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-offset="100"
      >
        <div class="col-12 col-md-5 offset-md-1 mb-4 mb-md-0 order-md-2">
          <div
            class="img-group d-flex"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-offset="100"
          >
            <div
              class="ratio img-1"
              style="--bs-aspect-ratio: 150%"
              v-if="partner_image1"
            >
              <div class="img-container">
                <img
                  width="300"
                  height="450"
                  class="img-fluid"
                  :title="partner_image1.title"
                  :alt="partner_image1.title"
                  :src="
                    generateThumbnail(
                      partner_image1.data.asset_url,
                      300,
                      450,
                      50,
                      'crop'
                    )
                  "
                />
              </div>
            </div>
            <div
              class="ratio img-2"
              style="--bs-aspect-ratio: 150%"
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-offset="100"
              data-aos-delay="500"
              v-if="partner_image2"
            >
              <div class="img-container">
                <img
                  width="300"
                  height="450"
                  class="img-fluid"
                  :title="partner_image2.title"
                  :alt="partner_image2.title"
                  :src="
                    generateThumbnail(
                      partner_image2.data.asset_url,
                      300,
                      450,
                      50,
                      'crop'
                    )
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <article v-html="partner_content"></article>
          <div class="row align-items-center mb-4">
            <div
              class="col-auto pe-4"
              v-for="partner in partner"
              :key="partner.id"
            >
              <router-link :to="{ name: 'ito.partner' }" class="partner-link">
                <img
                  height="20"
                  :width="
                    generateWidth(partner.logo.width, partner.logo.height)
                  "
                  class="img-fluid"
                  :src="
                    generateThumbnail(
                      partner.logo.data.asset_url,
                      130,
                      20,
                      30,
                      'contain'
                    )
                  "
                  :title="partner.title"
                  :alt="partner.title"
                />
              </router-link>
            </div>
          </div>
          <router-link
            :to="{ name: 'ito.partner' }"
            class="btn btn-outline-ito hover-red animated-arrow mt-3"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
              />
            </svg>
            Jetzt Partner erkunden
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

function parallaxEffect (el) {
  const ele = el[0]
  const containers = ele.getElementsByClassName('img-container')
  const play = function (ele) {
    var scrollPos = window.scrollY
    if (typeof ele !== 'undefined') {
      var rect = ele.getBoundingClientRect()
      var x = (rect.top - scrollPos) / 20.5
      if (window.innerWidth > 992 && containers.length > 0) {
        containers[0].style.transform = 'translateY(' + -x + 'px)'
        containers[1].style.transform = 'translateY(' + x + 'px)'
      }
    }
  }

  document.addEventListener('scroll', function (e) {
    play(ele)
  })
  play(ele)
}

export default {
  name: 'PartnerContent',
  data: function () {
    return {
      partner: {}
    }
  },
  async beforeMount () {
    await axios
      .get('/business_partner?fields=*.*')
      .then(
        (response) =>
          (this.partner = response.data.data.filter((i) => i.isvip === true))
      )
  },
  mounted () {
    parallaxEffect(document.getElementsByClassName('img-group'))
  },
  computed: {
    partner_content () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter((item) => {
          return item.title.indexOf('Homepage-Partner') > -1
        })
        return txt.length ? txt[0].content : ''
      } else {
        return ''
      }
    },
    partner_image1 () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter((item) => {
          return item.title.indexOf('Homepage-Partner') > -1
        })
        return txt.length ? txt[0].image : ''
      } else {
        return ''
      }
    },
    partner_image2 () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter((item) => {
          return item.title.indexOf('Homepage-Partner2-Bild') > -1
        })
        return txt.length ? txt[0].image : ''
      } else {
        return ''
      }
    }
  },
  methods: {
    generateThumbnail (asset, w, h, q, f) {
      return (
        'https://cdn.ito-consult.de' +
        asset +
        '?w=' +
        w +
        '&h=' +
        h +
        '&q=' +
        q +
        '&f=' +
        f
      )
    },
    generateWidth (w, h) {
      return parseInt((20 / h) * w)
    }
  }
}
</script>
